/* eslint-disable */

import type { GeneralLang } from "./types/GeneralLang";

let data: GeneralLang | undefined;

export type { GeneralLang };

export default function GeneralLangFactory(): GeneralLang {
  if (!data) {
    throw new Error("Trying to load a language in the main bundle before the language bundle is loaded");
  }
  return data;
}

export let setGeneralLang = (newLang: string) => {
  if (newLang === "en-GB") {
      return import(/* webpackChunkName: "en-GB.locale" */ "./en-GB/GeneralLangDef").then(({ GeneralLangDef }) => {
      data = GeneralLangDef;
    });
  } else if (newLang === "sv-SE") {
      return import(/* webpackChunkName: "sv-SE.locale" */ "./sv-SE/GeneralLangDef").then(({ GeneralLangDef }) => {
      data = GeneralLangDef;
    });
  } else if (newLang === "en-SE") {
      return import(/* webpackChunkName: "en-SE.locale" */ "./en-SE/GeneralLangDef").then(({ GeneralLangDef }) => {
      data = GeneralLangDef;
    });
  } else if (newLang === "ky-KG") {
      return import(/* webpackChunkName: "ky-KG.locale" */ "./ky-KG/GeneralLangDef").then(({ GeneralLangDef }) => {
      data = GeneralLangDef;
    });
  }
  else {
    throw new Error("Unsupported language/culture " + newLang);
  }
};

